/**
 * Select input for fields where we want to have control over whether certain options can be
 * removed. Fetches options remotely via the given url, and accepts an array of option ids
 * to protect and whether or not their removal should be allowed. If a user attempts to
 * remove an option with a protected id, they will either be told they cannot do that or
 * asked to confirm their decision, depending on the permissions given to this controller.
 *
 * Values: `url` - Should return an array of options with attributes `id` and `text`.
 * `protectedIds` - an array of option ids that should be protected from removal
 * `allowRemoval` - a boolean value indicating if protected ids can be removed by the user
 * `forbidMessage` - a string to display to user in alert if they cannot remove a protected item
 * `confirmMessage` - a string to display to user in a confirm if they can remove a protected item
 *
 */
import RemoteSelectController from "./remote_select_controller";

export default class extends RemoteSelectController {
  // url value is inherited from RemoteSelectController
  static values = {
    protectedIds: Array,
    allowRemoval: Boolean,
    forbidMessage: String,
    confirmMessage: String,
    multiple: Boolean,
  };

  configuration(overrides = {}) {
    const userTypeValue = this.element.dataset.outcomesRemoteSelectUserType;
    const searchField =
      userTypeValue === "teacher"
        ? ["text", "nu_description_teacher"]
        : ["text", "nu_description_student"];

    const config = super.configuration({
      searchField: searchField,
      onDelete: ([option_id]) => {
        if (this.protectedIdsValue.includes(option_id)) {
          if (this.allowRemovalValue) {
            return confirm(this.confirmMessageValue);
          } else {
            alert(this.forbidMessageValue);
            return false;
          }
        }
      },
      render: {
        option: function (data, escape) {
          let description =
            userTypeValue === "teacher" ? data.nu_description_teacher : data.nu_description_student;
          description = description ? description : "";
          return `
          <div>
            <p class="fw-bold mb-1">${escape(data.text)}</p>
            <p>${escape(description)}</p>
          </div>
          `;
        },
      },
      ...overrides,
    });

    if (!this.multipleValue) {
      config.onItemAdd = (value) => {
        this.element.value = value;
        const url = `${this.element.form.action}?outcome_id=${value}`;
        fetch(url, {
          headers: {
            Accept: "text/vnd.turbo-stream.html",
            "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
          },
          method: "PATCH",
        })
          .then((r) => r.text())
          .then((html) => {
            Turbo.renderStreamMessage(html);
            this.tomselect.clear();
          });
      };
    }

    return config;
  }
}
